'use client';

import { useQueryState } from 'nuqs';

export function useProductListingPageState(defaultPage = 1) {
  const [page, setPage] = useQueryState('page', {
    defaultValue: defaultPage,
    parse: (value) => Number.parseInt(value) || defaultPage,
    serialize: String,
    scroll: true,
  });

  return {
    page,
    updatePage: setPage,
  };
}
